import kutil from "./kutil";
import CommonCode from "./common_code";

function getValue(data: any) {
  if (data === null || data === undefined || data === "") {
    return "";
  }
  let value = data;
  if (typeof data == "object") {
    value = data.value;
  }
  if (typeof value == "number") {
    return "" + value;
  } else {
    return value || "";
  }
}

function dateFormatter(format: string) {
  return ((data: any) => kutil.date2string(data.value, format));
}

function timeFormatter(format: string) {
  return ((data: any) => kutil.time2string(data.value, format));
}

function codeFormatter(codeType: string) {
  return ((data: any) => CommonCode.getCodeValue(codeType, data.value));
}

function numberFormatter(data: any) {
  const value = getValue(data);
  return kutil.setComma(value);
}

function numberParser(value: string) {
  return value.replace(/[^0-9]/g, "");
}

function upperCaseFormatter(data: any) {
  const value = getValue(data);
  return value.toUpperCase();
}

function upperCaseParser(value: string) {
  return value.toUpperCase();
}

function lowerCaseFormatter(data: any) {
  const value = getValue(data);
  return value.toLowerCase();
}

function lowerCaseParser(value: string) {
  return value.toLowerCase();
}

function locationFormatter(data: any) {
  const value = getValue(data);
  if (value.length == 3) {
    return value;
  } else {
    const regExp = /0([0-9]{1,1})00([0-9]{1,1})([0-9]{3,3})([0-9]{2,2})/;
    return value.replace(regExp, "$1-$2-$3-$4");
  }
}

function locationIdFormatter(data: any) {
  const value = getValue(data);
  if (!value || value.length !== 10) {
    return "";
  }
  const s = String(parseInt(value.substring(0, 2), 10));
  const z = String(parseInt(value.substring(2, 5), 10));
  const x = String(parseInt(value.substring(5, 8), 10));
  const y = String(parseInt(value.substring(8, 10), 10));
  return `${s}-${z}-${x}-${y}`;
}

function locationIdParser(s: string, z: string, x: string, y: string, fillValue: "0" | "9" = "0") {
  if (!s && !z && !x && !y) {
    return "";
  }
  return (
    (s ? s.padStart(2, "0") : fillValue.repeat(2)) +
    (z ? z.padStart(3, "0") : fillValue.repeat(3)) +
    (x ? x.padStart(3, "0") : fillValue.repeat(3)) +
    (y ? y.padStart(2, "0") : fillValue.repeat(2))
  );
}

function percentFormatter(total: number, value: number, options: any) {
  if (!total) {
    return options.default;
  }
  const rate = (value ?? 0) * 100 / total;
  if (options.method === "FLOOR") {
    return (Math.floor(rate * Math.pow(10, options.scale)) / Math.pow(10, options.scale)).toFixed(options.scale);
  } else if (options.method === "CEIL") {
    return (Math.ceil(rate * Math.pow(10, options.scale)) / Math.pow(10, options.scale)).toFixed(options.scale);
  } else {
    return rate.toFixed(options.scale);
  }
}

export default {
  date: dateFormatter,
  time: timeFormatter,
  commonCode: codeFormatter,
  number: numberFormatter,
  numberParser: numberParser,
  upperCase: upperCaseFormatter,
  upperCaseParser: upperCaseParser,
  lowerCase: lowerCaseFormatter,
  lowerCaseParser: lowerCaseParser,
  location: locationFormatter,
  locationId: locationIdFormatter,
  locationIdParser: locationIdParser,
  percentFormatter: percentFormatter,
}
